import InboxInfiniteList from './InboxInfiniteList';
export default InboxInfiniteList;
